import { Controller } from '@hotwired/stimulus';

// .table-form のテキスト入力にフォーカス/ブラーで行(tr)に .focus を付け外しする
// (旧 main.js の .table-form ハンドラ)。
export default class extends Controller {
  focus(event) {
    const input = event.target;
    if (!input.matches('input[type=text]')) return;
    input.closest('tr')?.classList.add('focus');
  }

  blur(event) {
    const input = event.target;
    if (!input.matches('input[type=text]')) return;
    input.closest('tr')?.classList.remove('focus');
  }
}
